import { isInArray } from '../../../core/util/is-in-array';
import { getIdRange } from './helper';
import { HammerAction } from './media-picker-modal.actions';
import { initialState, State } from './media-picker-modal.reducer';

export const hammerReducer = (
    state: State = initialState,
    action: HammerAction
): State => {
    const payloadId = action.payload.id;
    const payloadModel = state.entities[action.payload.id];
    const payloadEventType = action.payload.eventType;
    console.log('hammer', payloadEventType, payloadId);
    switch (true) {
        case payloadEventType === 'press': {
            return {
                ...state,
                entities: {
                    ...state.entities,
                    [payloadId]: {
                        ...payloadModel,
                        selected: !payloadModel.selected,
                        timestamp: Date.now()
                    }
                },
                imageGridMode: 'selecting',
                selectFromId: payloadId,
                selectMode: !payloadModel.selected,
                touchState: 'down'
            };
        }
        case payloadEventType === 'pressup' || payloadEventType === 'touchend'
        : {
            return {
                ...state,
                imageGridMode: 'scrolling',
                touchState: 'up',
                selectFromId: undefined
            };
        }
        // when the user presses and drags
        case state.selectFromId && payloadEventType === 'touchmove': {
            const idsToSelect = getIdRange(
                state.selectFromId,
                payloadId,
                state.visibleIds
            );
            return {
                ...state,
                entities: state.ids
                    .reduce((newEntities, id) => {
                        newEntities[id] = !isInArray(id, idsToSelect) ?
                            state.entities[id] :
                            {
                                ...state.entities[id],
                                selected: state.selectMode
                            };
                        return newEntities;
                    }, {}),
                touchState: 'down'
            };
        }
        // when the user has previously released, and drags again
        case !state.selectFromId && payloadEventType === 'touchmove': {
            return {
                ...state,
                entities: {
                    ...state.entities,
                    [payloadId]: {
                        ...state.entities[payloadId],
                        selected: state.selectMode
                    }
                },
                touchState: 'down'
            };
        }
        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/modals-popovers/media-picker-modal/hammer.reducer.ts